import { u, styled } from '../../../../shared/theming-sc'

const FilterBodyBase = styled.div`
    float: left;
    width: 100%;
    margin-top: 20px;

    ${u.media.greaterThan('sm')`
        margin-top: 40px;
    `};
`

const FilterBody = styled.div`
    float: left;
    width: 100%;

`

const FilterBodyTitle = styled.div`
    margin-bottom: 20px;
    
`

const FilterItem = styled.div`
    width: 100%;
    box-sizing: border-box;
    float: left;
    padding: 0;
    position: relative;
    margin-bottom: ${u.getSpacing('small')}px;

    &:nth-child(3n + 3) {
        padding-right: 0;
    }

    ${u.media.greaterThan('sm')`
         width: 50%;
         padding-left: 10px;

         &:nth-child(2n + 1) {
            clear: both;
            padding-left: 0;
            padding-right: 10px;
        }
    `};

    ${u.media.greaterThan('lg')`
         width: 33%;
         padding-right: 0;
         padding-left: 0;

         &:nth-child(2n + 1) {
            clear: none;
            padding-right: 0;
        }

         &:nth-child(3n + 3) {
            padding-left: 10px;
        }

        &:nth-child(3n + 2) {
            padding-left: 10px;
            padding-right: 10px;
        }

        &:nth-child(3n + 1) {
            padding-left: 0px;
            padding-right: 10px;
        }

        &:nth-child(4) {
            clear: both;
        }

    `};
`

const FilterPositioner = styled.div`
`

const DateRangeHolder = styled.div`
    position: relative;
    left: 0;
    right: 0;
    width: 100%;

     ${u.media.greaterThan('sm')`
        right: ${u.getSpacing('large')}px;
        width: auto;
    `};

    input {
        width: 100% !important;
        border: solid 1px ${u.getColor('greyMuted')} !important;
        background-color: white !important;
        border-radius: 5px !important;
        padding: ${u.getSpacing('small')}px !important;
        color: ${u.getColor('greyDark')} !important;
        font-size: ${u.getFontSize('md')} !important;
    }
`

const FilterInput = styled.input`
    position: relative;
    border: solid 1px ${u.getColor('greyMuted')};
    background-color: #FFFFFF;
    border-radius: 5px;
    padding: 15px 20px;
    color: ${u.getColor('greyDark')};
    font-size: ${u.getFontSize('md')};
    width: 100%;
    height: 60px;
    outline: none !important;

    input::-ms-clear{
        display:none;
    }
`

const FilterLabel = styled.p`
    margin-bottom: ${u.getSpacing('smaller')}px;
`

export {
  FilterBody,
  FilterBodyBase,
  FilterBodyTitle,
  FilterPositioner,
  FilterItem,
  FilterInput,
  FilterLabel,
  DateRangeHolder
}
